// // Utility to display a full-screen confetti GIF overlay with highest z-index
// import confettie from "./../assets/images/confettie.gif";

// export function confettiWithHighestZIndex(options = {}) {
//   const { duration = 3000, zIndex = 99999 } = options;

//   // Create a full-screen image overlay
//   const img = document.createElement("img");
//   img.src = confettie;
//   img.alt = "confetti";
//   img.style.position = "fixed";
//   img.style.top = 0;
//   img.style.left = 0;
//   img.style.width = "100vw";
//   img.style.height = "100vh";
//   img.style.objectFit = "cover";
//   img.style.pointerEvents = "none";
//   img.style.zIndex = String(zIndex);
//   img.style.userSelect = "none";
//   img.style.webkitUserDrag = "none";

//   document.body.appendChild(img);

//   window.setTimeout(() => {
//     if (img.parentNode) {
//       img.parentNode.removeChild(img);
//     }
//   }, duration);
// }


// Utility to launch canvas-confetti with highest z-index
import confetti from "canvas-confetti";
import confettie from "./../assets/images/confettie.gif"

export function confettiWithHighestZIndex(options = {}) {
  // Create a temporary full-screen canvas with highest z-index
  const canvas = document.createElement("canvas");
  canvas.style.position = "fixed";
  canvas.style.top = 0;
  canvas.style.left = 0;
  canvas.style.width = "100vw";
  canvas.style.height = "100vh";
  canvas.style.pointerEvents = "none";
  canvas.style.zIndex = 99999;
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;
  document.body.appendChild(canvas);

  const myConfetti = confetti.create(canvas, { resize: true, useWorker: true });
  myConfetti({
    particleCount: 400,
    spread: 900,
    origin: { y: 0.5 },
    colors: [
      '#D9A053',
      '#F33CE5',
      '#EBF583',
      '#42C9E8',
      '#98FC3A',
    ],
    ...options,
  }).then(() => {
    setTimeout(() => {
      document.body.removeChild(canvas);
    }, 1000);
  });
}
